// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bg-image[data-v-539912f8]{background-image:var(--bg-mobile)}@media (min-width:1024px){.bg-image[data-v-539912f8]{background-image:var(--bg-desktop)}}.gradient-white[data-v-539912f8]{background:linear-gradient(180deg,hsla(0,0%,100%,0),#fff)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
